import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useContext } from '../../components/Order/Context'
import { ShowIf } from '@ztechapps/webui.util'
import { useGotoCart } from '../../hooks/useGotoCart'

export const GoToCartButton = () => {
  const { document, isStillNeedsPayment, canEditUsingStatus } = useContext()
  const [gotoCart, { loading }] = useGotoCart(document?._id)
  return (
    <ShowIf condition={isStillNeedsPayment && canEditUsingStatus}>
      <BusyButton
        icon={'shopping-cart'}
        text={'Checkout'}
        isBusy={loading}
        onClick={async () => {
          //this will handle the logic for updating the InCart and navigating to correct url
          await gotoCart()
        }}
      />
    </ShowIf>
  )
}
